export enum ModalRoleEnum {
  CONFIRM = 'CONFIRM',
  CANCEL = 'CANCEL',
  BACKDROP = 'backdrop'
}
